import { render, staticRenderFns } from "./ProductionTable.vue?vue&type=template&id=586c8778"
import script from "./ProductionTable.vue?vue&type=script&lang=js"
export * from "./ProductionTable.vue?vue&type=script&lang=js"
import style0 from "./ProductionTable.vue?vue&type=style&index=0&id=586c8778&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports